import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_get_vendor_lots_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { paging?: { top?: number, skip?: number }, filters?: { vendor_lot_id?: number, lookup?: string, material_id?: number, material_lookup?: string, project_id?: number, project_lookup?: string, owner_id?: number, owner_lookup?: string, vat?: string, expiration_date_from?: string, expiration_date_to?: string, manufacture_date_from?: string, manufacture_date_to?: string } }): Promise<{ vendor_lots?: $frontendTypes.FootprintApiManager.public_vendor_lot[], errors?: string[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

